import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type OaNoticeTone = 'info' | 'success' | 'warning' | 'danger' | 'neutral';

const ICONS: Record<OaNoticeTone, string> = {
    info: 'info',
    success: 'check_circle',
    warning: 'warning',
    danger: 'error',
    neutral: 'info',
};

/** Notice do DS (ORCA-1929): mensagem curta dentro de página, card ou diálogo. */
@Component({
    selector: 'oa-notice',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="oa-notice oa-notice--{{ tone }}" [attr.role]="tone === 'warning' || tone === 'danger' ? 'alert' : 'status'">
            <mat-icon aria-hidden="true">{{ icon || icons[tone] }}</mat-icon>
            <div>
                <span *ngIf="title" class="oa-notice__title">{{ title }}</span>
                <ng-content></ng-content>
                <div class="oa-notice__action"><ng-content select="[noticeAction]"></ng-content></div>
            </div>
        </div>
    `,
    styles: [':host { display: block; } .oa-notice__action:empty { display: none; }'],
})
export class OaNoticeComponent {
    @Input() tone: OaNoticeTone = 'info';
    @Input() title?: string;
    @Input() icon?: string;
    readonly icons = ICONS;
}
